import React, { useState } from "react";
import { Button, Chip, Input, Modal } from "../ui";
import "../../styles/content.css";

export const CATEGORY_LABEL = {
  rating: "ระดับเนื้อหา", flag: "ระดับธง", type: "ประเภท", role: "บทบาท", personality: "บุคลิกและนิสัย", media: "ประเภทสื่อ", lang: "ภาษาต้นฉบับ", event: "อีเวนต์",
};
const ORDER = ["flag", "rating", "type", "role", "personality", "media", "lang", "event"];

/** เลือกแท็กแบบแยกหมวด (modal) — selected = array ชื่อแท็ก */
export default function TagFilter({ open, onClose, tags, selected, onChange, max, title = "เลือกแท็ก" }) {
  const [q, setQ] = useState("");
  const [draft, setDraft] = useState(selected);
  React.useEffect(() => { if (open) { setDraft(selected); setQ(""); } }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  const toggle = (n) => setDraft((d) => (d.includes(n) ? d.filter((x) => x !== n) : max && d.length >= max ? d : [...d, n]));
  const groups = ORDER.map((c) => [c, tags.filter((t) => t.category === c && (!q || t.name.toLowerCase().includes(q.toLowerCase())))]).filter(([, l]) => l.length);
  const other = tags.filter((t) => !ORDER.includes(t.category) && (!q || t.name.includes(q)));
  if (other.length) groups.push(["other", other]);
  return (
    <Modal open={open} onClose={onClose} title={`${title} (${draft.length}${max ? `/${max}` : ""})`} size="lg"
      footer={<><Button variant="ghost" onClick={() => setDraft([])}>ล้างทั้งหมด</Button><Button variant="primary" onClick={() => { onChange(draft); onClose(); }}>ตกลง</Button></>}>
      <Input type="search" aria-label="ค้นหาแท็ก" placeholder="ค้นหาแท็ก..." value={q} onChange={(e) => setQ(e.target.value)} />
      {groups.length ? groups.map(([c, list]) => (
        <div className="tag-group" key={c}>
          <h4>{CATEGORY_LABEL[c] || "อื่น ๆ"}</h4>
          <div className="wrapchips">{list.map((t) => <Chip key={t.id} active={draft.includes(t.name)} onClick={() => toggle(t.name)}>{t.name}</Chip>)}</div>
        </div>
      )) : <p className="muted center">ไม่พบแท็ก</p>}
    </Modal>
  );
}
